// Piccola ragione di questo file:
// alcuni modali (QuickAddModal) fanno `history.back()` nel loro cleanup
// per rimuovere l'entry history spinta all'apertura. Quel popstate
// arriva a BackGuard anche se l'utente NON ha premuto il tasto indietro
// → BackGuard, non trovando più overlay nel DOM (modal già unmontato),
// lo interpreterebbe come "exit attempt" mostrando il toast sulla
// Dashboard. Usiamo un flag timestamp: chi fa il pop "silenzioso"
// chiama `suppressBackToast()`, BackGuard controlla `isSuppressed()`
// prima di mostrare il toast.

let suppressUntil = 0

export function suppressBackToast(ms = 400) {
  suppressUntil = Math.max(suppressUntil, Date.now() + ms)
}

export function isSuppressed() {
  return Date.now() < suppressUntil
}
